import {safeAccess} from '../../utils/objectUtils';

export class ShakaPlayerProxy {
  // We use any here because `shaka-player` npm package is not installed, because it has bad TypeScript definitions
  //  @see https://github.com/shaka-project/shaka-player/issues/6442)
  //   - we can't use "type imports" (`import type {}`),
  //   - we can't cover copies of the library values with unit tests
  //
  //   Shaka discussion about migration to TypeScript
  //   @see https://github.com/shaka-project/shaka-player/issues/8262
  constructor(private readonly rawPlayer: any) {}

  addEventListener = (type, listener) => {
    safeAccess(() => this.rawPlayer.addEventListener(type, listener));
  };

  removeEventListener = (type, listener) => {
    safeAccess(() => this.rawPlayer.removeEventListener(type, listener));
  };

  getMediaElement = () => safeAccess(() => this.rawPlayer.getMediaElement());

  isLive = () => safeAccess(() => this.rawPlayer.isLive());

  getAssetUri = () => safeAccess(() => this.rawPlayer.getAssetUri());

  getVariantTracks = () => safeAccess(() => this.rawPlayer.getVariantTracks());

  getManifestType = () => {
    // `getManifestType` is only available in shaka v4.4.0 and later (we need to support 4.0.0)
    return safeAccess(() => this.rawPlayer.getManifestType?.());
  };

  getLoadMode = () => safeAccess(() => this.rawPlayer.getLoadMode?.());

  get playerVersion(): string | undefined {
    return safeAccess(() => this.rawPlayer.constructor.version);
  }
}
